import { type QueryClient, useQuery } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  getCustomerExperiments,
  type Params as GetCustomerExperimentsParams,
} from '@hungryroot/rest/api/v2/customers/[id]/experiments/get';

const DEFAULT_PARAMS: Pick<GetCustomerExperimentsParams, 'limit' | 'offset'> = {
  limit: 999,
  offset: 0,
};

export type Props = {
  enabled: boolean;
};

export const invalidateCustomerExperiments = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: ['customer-experiments'] });
};

export function useApiV2CustomerExperiments({ enabled }: Props) {
  return useQuery({
    queryKey: ['customer-experiments'],
    queryFn: async () => {
      const resp = await getCustomerExperiments(DEFAULT_PARAMS);
      if (resp.status !== StatusCode.SuccessOK) {
        throw resp.data;
      }

      return resp.data;
    },
    select(data) {
      return {
        experiments: data.results,
      };
    },
    enabled,
  });
}
